import styles from './button.module.scss'

import { Button as MuiButton, type ButtonProps } from '@mui/material'
import clsx from 'clsx'
import type { ReactNode, SyntheticEvent } from 'react'

interface Props extends ButtonProps {
  variation?: 'primary' | 'secondary' | 'outline'
  callback?: (event: SyntheticEvent) => void // use onClick instead
  child?: ReactNode // use React children instead
}

export const Button = (props: Props) => {
  const {
    variation,
    className,
    callback,
    onClick,
    child,
    children,
    disabled,
    ...rest
  } = props

  return (
    <>
      <MuiButton
        {...rest}
        className={clsx(
          styles.button,
          variation && styles[variation],
          disabled && styles.disabled,
          className,
        )}
        disabled={disabled}
        onClick={onClick ?? callback}
        fullWidth
        disableElevation
      >
        {children ?? child}
      </MuiButton>
    </>
  )
}
